<app-navbar></app-navbar>
<app-hero></app-hero>
<app-trust-strip></app-trust-strip>
<app-stats></app-stats>
<app-services-section></app-services-section>
<app-global-network></app-global-network>
<app-testimonials></app-testimonials>
<app-industries></app-industries>
<app-faq></app-faq>
<app-process id="process"></app-process>
<app-quote-form id="quote"></app-quote-form>
<app-footer></app-footer>
